// extracted by mini-css-extract-plugin
export default {"container":"Vocentra_container__681Pq","leftRail":"Vocentra_leftRail__ncUVX","mainStage":"Vocentra_mainStage__qOa2q","rightPanel":"Vocentra_rightPanel__kmOTy"};